import { render, staticRenderFns } from "./profileBatchView.vue?vue&type=template&id=9a5f4920"
import script from "./profileBatchView.vue?vue&type=script&lang=js"
export * from "./profileBatchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports